import React from 'react';
import {
  Modal, Box, Button, ButtonVariant, Text,
} from '@usealloy/component-library';

export enum ApplyVerifyMode {
  CHANGE_OWNER = 'change-owner',
  DELETE_CRED = 'delete-cred',
}

interface ServiceCredentialApplyVerifyModalProps {
  mode: String;
  isOpen: boolean;
  onProceedAction(): void;
  onClose(): void;
}

const ServiceCredentialApplyVerifyModal: React.FC<ServiceCredentialApplyVerifyModalProps> = ({
  mode,
  isOpen,
  onProceedAction,
  onClose,
}) => {
  const laterButton = <Button onClick={onClose}>Later</Button>;
  const saveButton = (
    <Button variant={ButtonVariant.primary} onClick={onProceedAction}>
      {mode === ApplyVerifyMode.CHANGE_OWNER
        ? 'Apply'
        : 'Delete'}
    </Button>
  );

  return (
    <Modal
      header="Are you sure?"
      primaryAction={saveButton}
      secondaryAction={laterButton}
      size="small"
      onClose={onClose}
      isOpen={isOpen}
    >
      <Box direction="column" gap={5} justifyContent="flex-start" alignItems="flex-start">
        <Text size={2}>
          {mode === ApplyVerifyMode.CHANGE_OWNER
            ? 'By changing the owner of these credentials you are changing who may own payment for this data product. Changes will only be reflected once you save your workflow.'
            : 'By deleting these credentials you will remove any overridden credentials and use Service Settings credentials.'}
        </Text>
      </Box>
    </Modal>
  );
};

export default ServiceCredentialApplyVerifyModal;
